import React from 'react';
import {
  Row, Col
} from 'reactstrap';
import './Footer.css';

const Footer = () => {
  return (
    <div className="app-footer">
      <div className="app-footer__inner">
        <div className="container-fluid">
          <Row>
            <Col className="footer text-center">
              Powered by JK Tyre & Industries Ltd. © 2019, All Rights Reserved.
              Design & Developed by LoMoSo Solutions Pvt Limited
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Footer;